import React, {useEffect, useState} from 'react';
import DataTable, {TableColumn} from 'react-data-table-component';
import {confirmAlert} from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import {Button} from 'react-bootstrap';
import {toast} from 'react-toastify';
import DialogBox from '../../../components/DialogBox';
import { GrupoServicioContableApi } from '@app/api/integrador/GrupoServicioContableApi';
import GrupoServicioContableTable from './GrupoServicioContableTable';


interface GrupoServicioContable {
  idgruposerviciocontable: number;
  nombre: string;
  activo: boolean;
}

const GrupoServicioContable: React.FC = () => {
  const [data, setData] = useState<GrupoServicioContable[]>([]);
  const [editingData, setEditingData] = useState<GrupoServicioContable | null>(null);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [activo, setActivo] = useState<boolean>(editingData?.activo || false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleCloseGuardar = () => {
    setOpen(false);
  };

  const handleClose = () => {
    setOpen(false);
    handleReset();
  };

  const handleReset = () => {
    setEditingData(null);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await GrupoServicioContableApi.getGrupoServicioContable();
      setData(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Error al obtener los datos:', error);
    }
  };

  const handleEdit = (row: GrupoServicioContable) => {
    console.log('Editar:', row);
    setEditingData(row);
    handleOpen();
  };

  const handleDelete = (row: GrupoServicioContable) => {
    console.log('Eliminar:', row);
    confirmAlert({
      title: 'Confirmar eliminación',
      message: `¿Estás seguro que deseas eliminar el registro ${row.nombre}?`,
      buttons: [
        {
          label: 'Sí',
          onClick: () => {
            const newData = data.filter(
              (d: GrupoServicioContable) => d.idgruposerviciocontable !== row.idgruposerviciocontable
            );
            setData(newData);
          }
        },
        {
          label: 'No',
          onClick: () => {}
        }
      ]
    });
  };

  const handleSaveLinea = (row: GrupoServicioContable) => {
    var validacionDatos = '';
    if (row.idgruposerviciocontable) {
      if (row.nombre.length === 0) {
        validacionDatos = 'Nombre no puede estar en blanco';
      }
      const actualizacion = data.find((element) => {
        if (
          element.nombre.toUpperCase() === row.nombre.toUpperCase() &&
          element.idgruposerviciocontable !== row.idgruposerviciocontable
        ) {
          validacionDatos = 'Error Datos Duplicado, Valide el Catalogo';
          return true;
        }
      });
      if (validacionDatos.length === 0) {
        GrupoServicioContableApi.updateGrupoServicioContable(row.idgruposerviciocontable, row)
          .then(() => {
            setData((prevRow) =>
              prevRow.map((u) =>
                u.idgruposerviciocontable === row.idgruposerviciocontable ? row : u
              )
            );
            toast.success('Actualización Exitosa');
            handleReset();
            handleCloseGuardar();
          })
          .catch((err) => {
            toast.error('Error de Comunicación, Contacte a TI');
          });
      } else {
        toast.error(validacionDatos);
      }
    } else {
      if (row.nombre.length === 0) {
        validacionDatos = 'Nombre no puede estar en blanco';
      }
      const creacion = data.find((element) => {
        if (element.nombre.toUpperCase() == row.nombre.toUpperCase()) {
          validacionDatos = 'Error Datos Duplicado, Valide el Catalogo';
          return true;
        }
      });
      if (validacionDatos.length === 0) {
        GrupoServicioContableApi.createGrupoServicioContable(row)
          .then((response) => {
            setData((prevData) => [...prevData, response.data]);
            toast.success('Creación Exitosa');
            handleReset();
            handleCloseGuardar();
          })
          .catch((err) => {
            toast.error('Error de Comunicación, Contacte a TI');
          });
      } else {
        toast.error(validacionDatos);
      }
    }
  };

  const columns: TableColumn<GrupoServicioContable>[] = [
    {name: 'Nombre', selector: (row) => row.nombre},
    {
      name: 'Acciones',
      cell: (row: GrupoServicioContable) => (
        <div>
          <button
            onClick={() => handleEdit(row)}
            className="btn btn-primary btn-sm"
          >
            <i className="fa fa-pen"></i> Editar{' '}
          </button>
          &nbsp;
          <button
            onClick={() => handleDelete(row)}
            className="btn btn-danger btn-sm"
          >
            <i className="fa fa-eraser"></i> Eliminar{' '}
          </button>
        </div>
      )
    }
  ];

  return (
    <div>
      <Button variant="success" onClick={handleOpen}>
        <i className="fa fa-plus"></i> Agregar{' '}
      </Button>
      {loading ? (
        <p>Cargando...</p>
      ) : (
        <GrupoServicioContableTable
          data={data}
          columns={columns}
          customStyles={customStyles}
        />
      )}
      <DialogBox
        open={open}
        onClose={handleClose}
        title={editingData ? 'Editar' : 'Agregar'}
        content={
          <form
            onSubmit={(event) => {
              event.preventDefault();
              const formData = new FormData(event.currentTarget);
              const row: GrupoServicioContable = {
                idgruposerviciocontable: editingData?.idgruposerviciocontable || 0,
                nombre: formData.get('nombre') as string,
                activo
              };
              handleSaveLinea(row);
            }}
          >
            <div className="form-group" id="nombre">
              <label>Grupo de Servicio Contable</label>
              <div className="input-group mb-3">
                <div className="input-group-prepend">
                  <span className="input-group-text">Grupo de Servicio Contable</span>
                </div>
                <input
                  type="text"
                  name="nombre"
                  className="form-control "
                  defaultValue={editingData?.nombre}
                  placeholder="Ingrese el grupo de servicio contable"
                />
              </div>
            </div>
            <div className="form-group custom-control custom-checkbox">
              <input
                className="custom-control-input"
                type="checkbox"
                checked={activo}
                onChange={(e) => setActivo(e.target.checked)}
                defaultChecked={editingData?.activo}
                id="activo"
              />
              <label htmlFor="activo" className="custom-control-label">
                Activo
              </label>
            </div>

            <div className="modal-footer justify-content-between">
              <Button
                type="button"
                className="btn btn-danger"
                onClick={handleClose}
              >
                Cerrar
              </Button>
              <Button type="submit" className="btn btn-success">
                {editingData ? 'Guardar' : 'Agregar'}
              </Button>
            </div>
          </form>
        }
      />
    </div>
  );
};

const customStyles = {
  headCells: {
    style: {
      fontSize: '18px',
      fontWeight: 'bold',
      fontFamily: 'Arial'
    }
  },
  rows: {
    style: {
      fontSize: '18px'
    }
  },
  cells: {
    style: {
      fontSize: '16px'
    }
  },
  pagination: {
    style: {
      fontSize: '14px'
    }
  }
};

export default GrupoServicioContable;